@switch (permissionRole.permission.permission_control_type) {
  @case (PermissionControlType.Boolean) {
    <mat-checkbox
      color="primary"
      [checked]="PermissionValue.True === permissionRole.permission_value"
      (change)="changeRouter[PermissionControlType.Boolean]($event)"
      [disabled]="readOnly"
    ></mat-checkbox>
  }
  @case (PermissionControlType.AllOrNone) {
    <mat-checkbox
      color="primary"
      [checked]="PermissionValue.Everything === permissionRole.permission_value"
      (change)="changeRouter[PermissionControlType.AllOrNone]($event)"
      [disabled]="readOnly"
    ></mat-checkbox>
  }
  @case (PermissionControlType.AllOrTeamOrNone) {
    <ng-container
      *ngTemplateOutlet="selectTemplate; context: { $implicit: PermissionControlType.AllOrTeamOrNone }"
    ></ng-container>
  }
  @case (PermissionControlType.AllOrOwnerOrNone) {
    <ng-container
      *ngTemplateOutlet="selectTemplate; context: { $implicit: PermissionControlType.AllOrOwnerOrNone }"
    ></ng-container>
  }
  @case (PermissionControlType.AllOrTeamsOrOwnerOrNone) {
    <ng-container
      *ngTemplateOutlet="selectTemplate; context: { $implicit: PermissionControlType.AllOrTeamsOrOwnerOrNone }"
    ></ng-container>
  }
}

<ng-template #selectTemplate let-controlType>
  <mat-form-field>
    <mat-select
      (selectionChange)="changeRouter[controlType]($event)"
      [value]="permissionRole.permission_value"
      [disabled]="readOnly"
    >
      @for (option of PermissionControlTypeValue[controlType]; track option) {
        <mat-option [value]="option.name">{{ option.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</ng-template>
